import {
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FolderFilled,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import React from 'react';

const TYPE_LABELS = { image: 'Image', video: 'Vidéo', document: 'Document' };

const TYPE_ICONS = {
  image: <FileImageOutlined style={{ color: '#0958d9' }} />,
  video: <VideoCameraOutlined style={{ color: '#531dab' }} />,
  document: <FilePdfOutlined style={{ color: '#a8071a' }} />,
};

const renderName = (name, record) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      minWidth: 0,
    }}
  >
    {record.isFolder ? (
      <FolderFilled style={{ color: '#faad14', fontSize: 18 }} />
    ) : (
      (TYPE_ICONS[record.media_type] ?? <FileOutlined />)
    )}
    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</span>
    {record.already_sent_for_qualification && (
      <Tag color="blue" style={{ marginInlineEnd: 0 }}>
        Déjà envoyé
      </Tag>
    )}
  </span>
);

// Les dossiers et les fichiers partagent les colonnes : un dossier n'affiche
// que son nom et son type.
const fileOnly = (render) => (value, record) =>
  record.isFolder ? null : render ? render(value, record) : value;

export const getMediaTableColumns = () => [
  {
    title: 'Nom',
    dataIndex: 'name',
    key: 'name',
    sorter: true,
    ellipsis: true,
    render: renderName,
  },
  {
    title: 'Type',
    dataIndex: 'media_type',
    key: 'media_type',
    width: 110,
    render: (value, record) =>
      record.isFolder ? 'Dossier' : (TYPE_LABELS[value] ?? value),
  },
  {
    title: 'Format',
    dataIndex: 'media_format',
    key: 'media_format',
    width: 90,
    render: fileOnly(),
  },
  {
    title: 'Dimensions',
    dataIndex: 'dimensions',
    key: 'dimensions',
    sorter: true,
    width: 120,
    render: fileOnly(),
  },
  {
    title: 'Poids',
    dataIndex: 'size',
    key: 'size',
    sorter: true,
    width: 100,
    render: fileOnly(),
  },
  {
    title: 'Ajouté par',
    dataIndex: 'created_by',
    key: 'created_by',
    width: 150,
    ellipsis: true,
    render: fileOnly(),
  },
  {
    title: "Date d'ajout",
    dataIndex: 'created_at',
    key: 'created_at',
    sorter: true,
    width: 190,
    render: fileOnly(),
  },
];
